/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React from "react";

export default function PortfolioSingleGrid(props) {
  const { title, type, link, category, onImageClick } = props;

  return (
    <div className={`${category} item col-sm-6 col-md-4 col-lg-4 mb-4`} onClick={onImageClick}>
      <span className="item-wrap fancybox">
        <div className="work-info">
          <h3>{title}</h3>
          <span>{type}</span>
        </div>
        <img className="img-fluid" src={link} />
      </span>
    </div>
  );
}
